import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { isString } from '../utils.mjs';
var createUnitType = function createUnitType(unit) {
  return {
    test: function test(v) {
      return isString(v) && v.endsWith(unit) && v.split(" ").length === 1;
    },
    parse: parseFloat,
    transform: function transform(v) {
      return "".concat(v).concat(unit);
    }
  };
};
var degrees = createUnitType("deg");
var percent = createUnitType("%");
var px = createUnitType("px");
var vh = createUnitType("vh");
var vw = createUnitType("vw");
var progressPercentage = _objectSpread(_objectSpread({}, percent), {}, {
  parse: function parse(v) {
    return percent.parse(v) / 100;
  },
  transform: function transform(v) {
    return percent.transform(v * 100);
  }
});
export { degrees, percent, progressPercentage, px, vh, vw };